export class Deployment {
  name: string;
  id: string;
  status: string;
  location: string;
  scheduler: string;
  cloud: string;
  noOfJobs: number;
  adminUsername: string;
  profileUserId: string;
  totalSpend: any;
  lastUpdate: Date;
  totalNodes: number;
  numOfComputeNodes: number;
  coresPerNode: number;
  runningCores: number;
  totalUsers: string;
  totalJobOperators: string;
  totalPowerUsers: string;
  totalDeploymentAdmins: string;
  totalApplications: string;
  totalCores: number;
  hpcWallet: number;
  maxAllowedUsers: number;
  showBillingData: boolean;
  storageAccountName: string;
  storageType: string;
  userDepAccess?: { depName: string, role: string };
  maxNoOfCores: number;
  autoRescaleFlag: boolean | null;
  elasticLicenseBalance: number | null;
  idleTime: number | null;
  headNodeIp: string | null;
  deleteJobDataAfter: number | null;
  deleteJobsAfter: number | null;
  routeViaSynchpc: boolean | null;
  isVdi: boolean;
  copyJobDataToSyncstore: boolean;
  keepJobDataInWorkstore: boolean;
  showStorageProperties: boolean;
  showWorkstoreUpload: boolean;
  showWorkstoreDownload: boolean;
  useLowerCaseForNodes: boolean;
  isLocalStore: boolean;
  isCheckUtilityServiceEnabled: boolean;
  licenseConnectivity: string | null;
  licenseConnectivityColorCode: string | null;
  toShowStorageActions: boolean | null;
  partitionProp: PartitionProp[];
  nodeGroup: string;
  networkIpRange: string;
  subnetIpRange: string;
  computeNodeNames: string;
}

export class DeploymentParameter {
  depKey: string;
  depValue: string;

  constructor(key, value) {
    this.depKey = key;
    this.depValue = value
  }
}

export class DeploymentJsonBody {
  deploymentParameters: DeploymentParameter[];

  constructor(depParams) {
    this.deploymentParameters = depParams;
  }
}

export class DeploymentConfiguration {
  licenseFlag: boolean;
  autoScaleFlag: boolean;
  usePublicIPs: boolean;
}

export class PartitionProp {
  partitionName: string;
  instanceType: string;
  dynamicNodeCount: number;
  staticNodeCount: number;
  enablePlacement: boolean;
  gpuType: string;
  bootDiskType: string;
  bootDiskSize: string;
}
